// extracted by mini-css-extract-plugin
export default {"selectedRow":"StaffResultsTable_selectedRow__pb7Hf","openProfileButton":"StaffResultsTable_openProfileButton__Hury3"};